const message = {
  searchCity: "搜索城市",
  domestic: "国内",
  abroad: "国外",
};

export default message;
